import { createContext, useContext } from 'react';
import { Locale } from 'date-fns';
import { IMimeTypeFileSizes } from '../../feature/upload/types/IMimeTypeFileSizes.ts';

export const defaultContextValues = {
  datePicker: {
    dateTimeFormat: 'dd.MM.yyyy HH:mm',
    dateFormat: 'dd.MM.yyyy',
    locale: undefined,
  }
};

export type ConfigContextType = {
  mimeTypeFileSizes?: Partial<IMimeTypeFileSizes>;
  datePicker?: {
    dateTimeFormat?: string;
    dateFormat?: string;
    locale?: Locale;
  };
};
export const ConfigContext = createContext<ConfigContextType>(defaultContextValues);

export const useConfig = () => useContext(ConfigContext);
